import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PbbSvgIconComponent } from '../pbb-svg-icon/pbb-svg-icon.component';

@Component({
  selector: 'pbb-link-bank',
  imports: [TranslateModule, PbbSvgIconComponent, RouterLink],
  templateUrl: './link-bank.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkBankComponent {
  @Input() urlPath = 'linkBank';
  @Input() email = '';
  @Input() showBackButton = false;
}
